import React, { useEffect, useRef, useState } from "react";

import {
  Content,
  IconArrowLeft,
  FormVaga,
  Linha,
  ContainerRequisitos,
  StyledTag,
  IconEdit,
  IconDelete,
  FundoAlunos,
  ContainerAlunos,
  CardCandidato,
  ContainerCandidatos,
  ButtonLink,
  ContainerActions,
  Button,
  Overlay,
  ModalContatos,
  ImageProfileContainer,
  ModalEncerrar,
  ModalContratei,
  Actions,
  Link,
  IconReopen,
} from "./styles";
import { Container } from "../../../styles/GlobalStyles";
import Header from "../../../components/Header";
import { useHistory, useParams } from "react-router-dom";
import { api } from "../../../services/api";
import {
  FaAddressBook,
  FaAddressCard,
  FaAt,
  FaFacebook,
  FaFileSignature,
  FaGraduationCap,
  FaInstagram,
  FaLinkedin,
  FaMobileAlt,
  FaPhone,
  FaTimes,
  FaWheelchair,
  FaFileAlt,
} from "react-icons/fa";
import { mascaraCelular } from "../../../services/utils";

import animationData from "../../../assets/contract-sign.json";
import animationDataConfeti from "../../../assets/confetti.json";
import imgProfileM from "../../../assets/profile_m.png";
import imgProfileF from "../../../assets/profile_f.png";
import Lottie from "react-lottie";
import SpinnerLoading from "../../../components/SpinnerLoading";
import Alerts from "../../../components/Alerts";
import Confirm from "../../../components/Confirm";

function DetalheVaga() {
  const history = useHistory();
  const { id: vagaId } = useParams();
  const headerLinks = [{ label: "Sair", to: "/" }];

  const encerrarRef = useRef();

  const [vaga, setVaga] = useState({});
  const [requisitos, setRequisitos] = useState([]);
  const [beneficios, setBeneficios] = useState([]);

  const [mensagem, setMensagem] = useState(undefined);
  const [confirm, setConfirm] = useState(undefined);
  const [confirmReopen, setConfirmReopen] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const buscarVagaDetalhe = async () => {
      setLoading(true);
      try {
        const retorno = await api.get(`/empresas/vagas/${vagaId}`);

        setVaga(retorno.data);

        setLoading(false);
      } catch (e) {
        setLoading(false);
        return setMensagem({
          show: true,
          titulo: "Ops",
          detalhe: "Tivemos um problema no servidor",
        });
      }
    };

    buscarVagaDetalhe();
  }, [vagaId]);

  useEffect(() => {
    if (vaga.requisitos) {
      setRequisitos(vaga.requisitos.split(";"));
    }
    if (vaga.beneficios) {
      setBeneficios(vaga.beneficios.split(";"));
    }
  }, [vaga]);

  const handlerConfirm = () => {
    encerrarRef.current.style.display = "flex";
    setTimeout(() => {
      encerrarRef.current.style.opacity = "1";
    }, 50);
  };

  const handlerEncerrar = async () => {
    try {
      await api.patch(`/vagas/${vaga.id}`, { status: 2 });

      history.replace("/empresa/vagas");
    } catch (e) {
      console.log(e);
    }
  };

  const handlerExcluir = async () => {
    setConfirm(undefined);
    setLoading(true);
    try {
      await api.delete(`/vagas/${vaga.id}`);

      setLoading(false);

      history.replace("/empresa/vagas", {
        mensagem: "Vaga excluída com sucesso.",
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handlerReabrir = async () => {
    setConfirmReopen(undefined);
    setLoading(true);
    try {
      await api.patch(`/vagas/${vaga.id}`);

      setLoading(false);

      setVaga({ ...vaga, status: 1 });
    } catch (e) {
      console.log(e);
    }
  };

  const irParaBuscarAlunos = () => {
    history.push("/empresa/buscar-alunos", { vaga });
  };

  return (
    <Container>
      <Confirm
        mensagem={confirm}
        setMensagem={setConfirm}
        handleConfirm={handlerExcluir}
      />
      <Confirm
        mensagem={confirmReopen}
        setMensagem={setConfirmReopen}
        handleConfirm={handlerReabrir}
      />
      <Alerts mensagem={mensagem} setMensagem={setMensagem} tipo="erro" />
      <Header links={headerLinks} theme="black" />
      <Content>
        <header>
          {!loading &&
          vaga.status === 1 ? (
            <Actions>
              <IconEdit
                onClick={() => history.push("/empresa/editar-vaga", { vaga })}
                size={25}
              />
              <IconDelete
                onClick={() =>
                  setConfirm({
                    show: true,
                    titulo: "Deseja realmente excluir a vaga?",
                    detalhe: "Se excluir irá perder os dados cadastrados.",
                  })
                }
                size={25}
              />
            </Actions>
          ) : (
            <Actions>
              <IconReopen
                title="Reabrir vaga"
                onClick={() =>
                  setConfirmReopen({
                    show: true,
                    titulo: "Deseja realmente reabrir a vaga?",
                  })
                }
                size={25}
              />
            </Actions>
          )}
          <IconArrowLeft onClick={history.goBack} size={25} />
          <h1>
            {vaga.tipo_vaga} - {vaga.cargo}
          </h1>
          <h2>
            {vaga.qtd_vagas} {vaga.qtd_vagas > 1 ? "vagas" : "vaga"}
          </h2>
        </header>
        {loading ? (
          <SpinnerLoading />
        ) : (
          <>
            <FormVaga>
              <div>
                <label>Responsabilidades e atribuições</label>
                <p>{vaga.atribuicoes}</p>
              </div>
              <div>
                <label>Pré Requisitos</label>
                {requisitos.length === 0 ? (
                  <p>Não informado</p>
                ) : (
                  <ContainerRequisitos>
                    {requisitos.map((r, i) => (
                      <Tag key={i} info={r} />
                    ))}
                  </ContainerRequisitos>
                )}
              </div>
              <Linha>
                <label>Local de Trabalho</label>
                <p>{vaga.local_trabalho}</p>
              </Linha>
              <div>
                <label>Horário</label>
                <p>{vaga.horario}</p>
              </div>
              <div>
                <label>Salário</label>
                <p>R$ {vaga.salario}</p>
              </div>
              <div>
                <label>Benefícios</label>
                {beneficios.length === 0 ? (
                  <p>Não informado</p>
                ) : (
                  <ContainerRequisitos>
                    {beneficios.map((b, i) => (
                      <Tag key={i} info={b} />
                    ))}
                  </ContainerRequisitos>
                )}
              </div>
              <div>
                <label>Observações</label>
                <p>{vaga.observacoes}</p>
              </div>
            </FormVaga>
            <Candidatos vaga={vaga} buscarAlunos={irParaBuscarAlunos} />
            {vaga.status !== 2 && (
              <Button style={{ width: "100%" }} onClick={handlerConfirm}>
                Encerrar Vaga
              </Button>
            )}
          </>
        )}
      </Content>
      <EncerrarVaga
        ref={encerrarRef}
        vaga={vaga}
        handlerEncerrar={handlerEncerrar}
      />
    </Container>
  );
}

const Candidatos = ({ vaga, buscarAlunos }) => {
  const [candidatos, setCandidatos] = useState({
    novos: [],
    vistos: [],
    contratados: [],
  });

  const contatosRef = useRef();
  const contrateiRef = useRef();

  const [candidatoSel, setCandidatoSel] = useState({});
  const [candidatoContratar, setCandidatoContratar] = useState({});

  useEffect(() => {
    const buscarCandidatos = async () => {
      try {
        const retorno = await api.get(`/vagas/${vaga.id}/candidatos`);

        setCandidatos(retorno.data);
      } catch (e) {
        console.log(e);
      }
    };

    if (vaga.id) {
      buscarCandidatos();
    }
  }, [vaga]);

  const atualizarVistos = async (candidato) => {
    try {
      await api.post(`/vagas/${vaga.id}/vistos`, { aluno_id: candidato.cpf });

      setCandidatos((cand) => ({
        ...cand,
        novos: cand.novos.filter((c) => c.cpf !== candidato.cpf),
        vistos: [candidato, ...cand.vistos],
      }));
    } catch (e) {
      console.log(e);
    }
  };

  const carregarDetalheCandidato = async (c, naoVisto) => {
    try {
      const retorno = await api.get(`/vagas/${vaga.id}/candidatos/${c.cpf}`);

      if (naoVisto) atualizarVistos(c);

      setCandidatoSel(retorno.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (Object.keys(candidatoSel).length !== 0) {
      contatosRef.current.style.display = "flex";
      setTimeout(() => {
        contatosRef.current.style.opacity = "1";
      }, 50);
    }
  }, [candidatoSel, vaga.id]);

  useEffect(() => {
    if (Object.keys(candidatoContratar).length !== 0) {
      contrateiRef.current.style.display = "flex";
      setTimeout(() => {
        contrateiRef.current.style.opacity = "1";
      }, 50);
    }
  }, [candidatoContratar]);

  const handlerContratar = (candidato) => {
    setCandidatos((cand) => ({
      ...cand,
      vistos: cand.vistos.filter((c) => c.cpf !== candidato.cpf),
      contratados: [candidato, ...cand.contratados],
    }));
  };

  return (
    <>
      <Contratei
        ref={contrateiRef}
        candidato={candidatoContratar}
        handlerContratar={handlerContratar}
        setCandidato={setCandidatoContratar}
        vaga={vaga}
      />
      <FundoAlunos>
        <ContainerAlunos>
          <header>
            <h1>
              <em>{vaga.qtd_candidatos}</em> candidatos de{" "}
              <em>{vaga.qtd_alunos_vinculados}</em> alunos vinculados
            </h1>
          </header>

          <>
            <span style={{ color: "var(--darkGreen)" }}>Novos:</span>
            {candidatos.novos.length === 0 &&
              "Ainda não temos nenhum novo candidato."}
            <ContainerCandidatos>
              {candidatos.novos.map((c, i) => (
                <CardCandidato key={c.cpf}>
                  <h3>{c.nome_aluno.toUpperCase()}</h3>
                  <span>
                    <strong>{c.idade}</strong> anos. Mora em{" "}
                    <strong>{c.municipio}.</strong>
                  </span>
                  <label>Último curso</label>
                  <p>
                    {c.ultimo_curso} - {c.concluido_em}
                  </p>
                  <br></br>
                  <hr />
                  <ContainerActions>
                    <ButtonLink
                      onClick={() => carregarDetalheCandidato(c, true)}
                    >
                      <FaAddressCard size={20} /> Detalhes
                    </ButtonLink>
                  </ContainerActions>
                </CardCandidato>
              ))}
            </ContainerCandidatos>

            {candidatos.vistos.length !== 0 && (
              <>
                <br />
                <hr />
                <br />
                <span>Vistos:</span>
                <ContainerCandidatos>
                  {candidatos.vistos.map((c, i) => (
                    <CardCandidato key={c.cpf}>
                      <h3>{c.nome_aluno.toUpperCase()}</h3>
                      <span>
                        <strong>{c.idade}</strong> anos. Mora em{" "}
                        <strong>{c.municipio}.</strong>
                      </span>
                      <label>Último curso</label>
                      <p>
                        {c.ultimo_curso} - {c.concluido_em}
                      </p>
                      <br></br>
                      <hr />
                      <ContainerActions>
                        <ButtonLink onClick={() => carregarDetalheCandidato(c)}>
                          <FaAddressCard size={20} /> Detalhes
                        </ButtonLink>
                        <ButtonLink
                          color="darkGreen"
                          onClick={() => setCandidatoContratar(c)}
                        >
                          <FaFileSignature size={20} /> Contratei!
                        </ButtonLink>
                      </ContainerActions>
                    </CardCandidato>
                  ))}
                </ContainerCandidatos>
              </>
            )}

            {candidatos.contratados.length !== 0 && (
              <>
                <br />
                <hr />
                <br />
                <span>Contratados:</span>
                <ContainerCandidatos>
                  {candidatos.contratados.map((c, i) => (
                    <CardCandidato key={c.cpf}>
                      <h3>{c.nome_aluno.toUpperCase()}</h3>
                      <span>
                        <strong>{c.idade}</strong> anos. Mora em{" "}
                        <strong>{c.municipio}.</strong>
                      </span>
                      <label>Último curso</label>
                      <p>
                        {c.ultimo_curso} - {c.concluido_em}
                      </p>
                      <br></br>
                      <hr />
                      <ContainerActions>
                        <ButtonLink onClick={() => carregarDetalheCandidato(c)}>
                          <FaAddressCard size={20} /> Detalhes
                        </ButtonLink>
                      </ContainerActions>
                    </CardCandidato>
                  ))}
                </ContainerCandidatos>
              </>
            )}
          </>
          {vaga.status !== 2 && (
            <div
              style={{
                display: "flex",
                marginTop: 20,
                justifyContent: "center",
              }}
            >
              <Button
                onClick={buscarAlunos}
                color="green"
                style={{ width: "50%", alignSelf: "center" }}
              >
                 {vaga.qtd_alunos_vinculados > 0
                  ? "Buscar Mais Alunos"
                  : "Buscar Alunos"}
              </Button>
            </div>
          )}
        </ContainerAlunos>
      </FundoAlunos>
      <DetalheCandidato
        candidato={candidatoSel}
        setCandidato={setCandidatoSel}
        ref={contatosRef}
      />
    </>
  );
};

const DetalheCandidato = React.forwardRef(
  ({ candidato, setCandidato }, ref) => {
    const handlerOverlay = (e) => {
      if (e.target.id === "overlay") {
        handlerClose();
      }
    };

    const handlerClose = () => {
      ref.current.style.opacity = "0";

      setTimeout(() => {
        ref.current.style.display = "none";
        setCandidato({});
      }, 200);
    };

    return (
      <Overlay id="overlay" ref={ref} onClick={handlerOverlay}>
        <ModalContatos>
          <span>
            <FaTimes onClick={handlerClose} />
          </span>
          <section id="pessoais">
            <ImageProfileContainer>
              <img
                src={candidato.sexo === "M" ? imgProfileM : imgProfileF}
                alt="Imagem de Perfil"
              />
            </ImageProfileContainer>
            <div>
              <h1>{candidato.nome_aluno}</h1>
              <span>
                {candidato.idade} anos -{" "}
                {candidato.sexo === "M" ? "Masculino" : "Feminino"} -{" "}
                {candidato.municipio}
                {candidato.pcd !== "Não Possui" && (
                  <FaWheelchair
                    color="blue"
                    style={{ marginLeft: 10 }}
                    size={20}
                  />
                )}{" "}
              </span>
              <p>
                {candidato.trabalhando
                  ? "Candidato empregado, porém aceitando propostas."
                  : ""}
              </p>
            </div>
          </section>
          <section id="cursos">
            <hr />
            <label>
              <FaGraduationCap size={30} /> Cursos SENAI
            </label>
            <ul>
              {candidato.cursos &&
                candidato.cursos.map((c, i) => (
                  <li key={c.id}>
                    <strong>{c.nome}</strong> - {c.carga_horaria} horas.
                    Concluído em <strong>{c.data_conclusao}.</strong>
                  </li>
                ))}
            </ul>
          </section>
          <section id="curriculo">
            <hr />
            <label>
              <FaFileAlt size={25} /> Currículo
            </label>
            {!candidato.link_curriculo || candidato.link_curriculo === "" ? (
              <p>
                O candidato não informou o currículo, entre em contato e
                solicite.
              </p>
            ) : (
              <a href={candidato.link_curriculo} target="__blank">
                - Acessar currículo &#10140;
              </a>
            )}
          </section>
          <section id="contatos">
            <hr />
            <label>
              <FaAddressBook size={25} /> Contatos
            </label>
            {candidato.telefones &&
              candidato.telefones.map((t, i) => (
                <div key={t.id}>
                  <span id="contato">
                    {t.tipo === "C" ? (
                      <FaMobileAlt size={20} />
                    ) : (
                      <FaPhone size={20} />
                    )}
                    {mascaraCelular(t.ddd + t.numero)}
                  </span>
                  {t.whatsapp ? (
                    <em
                      onClick={() =>
                        window.open(
                          `https://api.whatsapp.com/send?phone=55${
                            t.ddd + t.numero
                          }&text=Olá, vi seu perfill no Senai.JOB!`
                        )
                      }
                    >
                      Conversar no whatsapp
                    </em>
                  ) : (
                    ""
                  )}
                </div>
              ))}
            <span id="contato">
              <FaAt size={22} /> {candidato.email}
            </span>
            <em
              onClick={() => {
                window.location.href = `mailto:${candidato.email}`;
              }}
            >
              Enviar e-mail
            </em>
            {candidato.facebook && (
              <>
                <span id="contato">
                  <FaFacebook size={22} />{" "}
                  <a target="__blank" href={`${candidato.facebook}`}>
                    {" "}
                    Abrir facebook
                  </a>
                </span>
              </>
            )}
            {candidato.instagram && (
              <>
                <span id="contato">
                  <FaInstagram size={22} />
                  <a target="__blank" href={`${candidato.instagram}`}>
                    Abrir Instagram
                  </a>
                </span>
              </>
            )}
            {candidato.linkedin && (
              <>
                <span id="contato">
                  <FaLinkedin size={22} />
                  <a target="__blank" href={`${candidato.linkedin}`}>
                    Abrir Linkedin
                  </a>
                </span>
              </>
            )}
          </section>
        </ModalContatos>
      </Overlay>
    );
  }
);

const Contratei = React.forwardRef(
  ({ candidato, handlerContratar, setCandidato, vaga }, ref) => {
    const [confirmado, setConfirmado] = useState(false);

    const defaultOptions = {
      loop: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    const defaultOptions2 = {
      loop: false,
      animationData: animationDataConfeti,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    const handlerOverlay = (e) => {
      if (e.target.id === "overlay") {
        handlerClose();
      }
    };

    const handlerClose = () => {
      ref.current.style.opacity = "0";
      setTimeout(() => {
        ref.current.style.display = "none";
        setCandidato({});
      }, 200);
    };

    const contratar = () => {
      try {
        api.post(`/vagas/${vaga.id}/candidatos/${candidato.cpf}/contrato`);

        setConfirmado(true);

        setTimeout(() => {
          handlerClose();
        }, 2000);

        handlerContratar(candidato);
      } catch (e) {
        console.log(e);
      }
    };

    return (
      <Overlay
        id="overlay"
        ref={ref}
        onClick={handlerOverlay}
        // style={{ display: "flex", opacity: 1 }}
      >
        {confirmado ? (
          <Lottie options={defaultOptions2} width="80%" />
        ) : (
          <ModalContratei>
            <span>
              <FaTimes onClick={handlerClose} />
            </span>
            <h3>Confirmar contratação?</h3>
            <Lottie options={defaultOptions} />
            <Button color="green" style={{ width: "100%" }} onClick={contratar}>
              Sim
            </Button>
          </ModalContratei>
        )}
      </Overlay>
    );
  }
);

const EncerrarVaga = React.forwardRef(({ vaga, handlerEncerrar }, ref) => {
  const handlerOverlay = (e) => {
    if (e.target.id === "overlay") {
      handlerClose();
    }
  };

  const handlerClose = () => {
    ref.current.style.opacity = "0";
    setTimeout(() => {
      ref.current.style.display = "none";
    }, 200);
  };

  return (
    <Overlay id="overlay" ref={ref} onClick={handlerOverlay}>
      <ModalEncerrar>
        <span>
          <FaTimes onClick={handlerClose} />
        </span>
        <p>
          Antes de encerrar é imporante que você marque os candidatos
          contratados.
        </p>
        <Button color="green" style={{ width: "100%" }} onClick={handlerClose}>
          Marcar Contratados
        </Button>
        <p>Ou, se está tudo ok.</p>
        <Link style={{ width: "100%" }} color="green" onClick={handlerEncerrar}>
          Encerrar
        </Link>
      </ModalEncerrar>
    </Overlay>
  );
});

const Tag = ({ info, closable }) => {
  return <StyledTag>{info}</StyledTag>;
};

export default DetalheVaga;
